/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createCampaignFromAtsJobDataSchema = z.object({
	organisationId: z.string().uuid(),
	exportIntegrationId: z.string().uuid(),
	atsJobId: z.string(),
	campaignId: z.string().uuid(),
	brandingId: z.string().uuid(),
	generateKeyImage: z.boolean().nullable().optional(),
})

export type CreateCampaignFromAtsJobDataSchema = z.infer<typeof createCampaignFromAtsJobDataSchema>
